/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Button } from '@insticator/insticator-ui'; // iui-material
import OrganizeContentPage from 'pages/dashboard/embeds/management/organize/organize_container';
// utils
import { isContentValid } from 'utils/embedcontentvalidation';
// styles
import injectSheet from 'react-jss';
import styles from 'material/ctas/organizecontent/organizecontent_styles';



/* ========== ~~~~~~~~~~ CTA : ORGANIZE CONTENT ~~~~~~~~~~ ========== */
const OrganizeContentCTA = (props) => {
	function handleClick(e) {
		e.preventDefault();
        if(isContentValid(props.selectedContent)) {
            props.displayModal(true, <OrganizeContentPage />);
        } else {
            props.invalidateSelectedContent();
            props.sendMessage('There are required fields you must fill out before continuing.');
        }
	}
    return(
        <Button type={`custom`} handleClick={handleClick} variant={`primary`} name={`organizecontent`} text={`Organize Cards`} klass={props.classes.organizecontent} />
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(OrganizeContentCTA);
